<template>
	<el-input v-model="propValue" placeholder="请输入内容" style="width: 217px;" @change="changeInput"></el-input>
</template>

<script>
export default {
	name:'propinput',
	props:['pid','myValue'],
	data(){
		return {
			propValue: this.myValue
		}
	},
	watch:{
	},
	methods:{
		changeInput(){
			this.$emit("changeInput",this.pid,this.propValue);
		}
	}
}
</script>

<style>
</style>